import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({ selector: '[form-view]' })

export class FormViewDirective {

  isShow: boolean = true;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  addChildClass() {
    this.renderer.addClass(this.el.nativeElement, "form-child");
  }

  hide() {
    this.isShow = false;
    this.toggleDisplay();
  }
  show() {
    this.isShow = true;
    this.toggleDisplay();
  }

  toggle() {
    this.isShow = !this.isShow;
    this.toggleDisplay();
  }
  toggleValue(value) {
    this.isShow = value;
    this.toggleDisplay();
  }

  toggleDisplay() {
    if (this.isShow) {
      this.renderer.removeClass(this.el.nativeElement, "hide");
    } else {
      this.renderer.addClass(this.el.nativeElement, "hide");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/form/core/directive/form-view.directive.ts